import { render } from "./index.vue?vue&type=template&id=ffe3faea&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=ffe3faea&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe3faea"]])

export default __exports__